import {
  cilApplicationsSettings,
  cilBuilding,
  cilClipboard,
  cilFactory,
  cilHome,
  cilLayers,
  cilLocationPin,
  cilMenu,
  cilNotes,
  cilPeople,
  cilUser
} from '@coreui/icons';

export const iconSubset = {
  cilApplicationsSettings,
  cilMenu,
  cilHome,
  cilPeople,
  cilBuilding,
  cilClipboard,
  cilNotes,
  cilUser,
  cilLayers,
  cilFactory,
  cilLocationPin
};
